import Vue from 'vue';
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';

const contractInfo = require('./multiCallContract.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.multiCallContractAddress;
let contractConst = {
  contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getMultiCallAddress = () => {
  return contractAddress;
}

const getMultiCallContract = () => {
  return contractConst.contract;
}

const multiCall = ([calls, handles, handlerParams], options) => {
  return $web3js.call(getMultiCallContract().methods.aggregate, [calls], options, handlelMultiCall, [handles, handlerParams]);
}

const handlelMultiCall = async (res, handles, handlerParams) => {
  let results = [];
  await res.returnData.map(async (item, index) => {
    let handler = handles.length >= index + 1 ? handles[index] : undefined;
    let params = handlerParams.length >= index + 1 ? handlerParams[index] : [];
    if (handler && typeof handler === 'function') {
      let data = handler(item, ...params);
      if (!!data.then) {
        data = await data.then();
        results[index] = data;
      } else {
        results[index] = data;
      }
    } else {
      results[index] = item;
    }
  })

  return results;
}

export default {
  getMultiCallAddress,
  getMultiCallContract,
  multiCall,
}


// WEBPACK FOOTER //
// ./src/lib/contract/multiCall/index.js